import './EditPackageHazards.scss';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import Error from '../../common/Error/Error';
import Checkbox from '../Checkbox/Checkbox';
import Job from '../../api/controllers/Job/Job';
import Packages from '../../api/controllers/Packages/Packages';

// EditPackageHazards Component
const EditPackageHazards = ({ packages, setModalOpen, refetchPackages }) => {
  const [dangerousGoods, setDangerousGoods] = useState([]);
  const [selectedHazards, setSelectedHazards] = useState([]);
  const [accurate, setAccurate] = useState();
  const [visible, setVisible] = useState();
  const [error, setError] = useState();

  const getDangerousGoods = () => {
    Job.show(packages[0]?.package.job.id)
      .then(response => {
        setDangerousGoods(response.dangerousGoodsLines);
        setSelectedHazards(response.dangerousGoodsLines);
      })
      .catch(e => {
        setError(e.errors || e.error);
      });
  };

  const updatePackageHazards = () => {
    const ids = packages.map(p => p.package.id);
    const data = {
      labelStatus: accurate,
      labelVisible: visible,
      dangerousGoodsAssociationsAttributes: selectedHazards.map(hazard => {
        return { dangerousGoodsLineItemId: hazard.id };
      }),
    };

    Packages.update(ids, data)
      .then(() => {
        refetchPackages();
        setModalOpen(false);
      })
      .catch(e => {
        setError(e.errors || e.error);
      });
  };

  const toggleSelected = dangerousGood => {
    if (selectedHazards.some(selectedItem => selectedItem.id === dangerousGood.id)) {
      const updatedPackages = selectedHazards.filter(selectedItem => {
        return selectedItem.id !== dangerousGood.id;
      });
      setSelectedHazards(updatedPackages);
    } else {
      setSelectedHazards([...selectedHazards, dangerousGood]);
    }
  };

  useEffect(() => {
    getDangerousGoods();
  }, []);

  return (
    <div className="edit_package_hazards_container">
      {error && (
        <Error
          errorMessages={error}
          type={'error'}
          errorTitle={
            Array.isArray(error)
              ? `${error.length} error${
                  error.length > 1 ? 's' : ''
                } prohibited this item from being saved: `
              : ''
          }
        />
      )}
      <div className="affected_packages">
        {packages.length > 0 &&
          `This action applies to ${
            packages.length > 3
              ? `${packages.length} packages`
              : `${packages[0].packageName}${
                  packages[1]
                    ? `${packages.length > 2 ? ',' : ' and'} ${packages[1].packageName}`
                    : ''
                }${packages[2] ? ` and ${packages[2].packageName}` : ''}`
          } `}
      </div>
      <div className="hazard_selection section">
        Which kinds of dangerous goods are included within this package?
        {dangerousGoods.map(dangerousGood => {
          return (
            <div className="dangerous_good_selection" key={dangerousGood.id}>
              <Checkbox
                label={`hazard_checkbox_${dangerousGood.id}`}
                selected={selectedHazards?.some(
                  selectedHazard => selectedHazard.id == dangerousGood.id,
                )}
                handleClick={() => toggleSelected(dangerousGood)}
              />
              {dangerousGood.longText}
            </div>
          );
        })}
      </div>
      <div className="label_accuracy section">
        Is the package labelling accurate with regard to the above? Choose one of the below options:
        <div className="label_accuracy_checkboxes">
          <div className="accuracy_selection">
            <Checkbox
              selected={accurate == 'correct'}
              handleClick={() => setAccurate('correct')}
              label="hazard_accurate_correct"
            />
            Correct
          </div>
          <div className="accuracy_selection">
            <Checkbox
              selected={accurate == 'incorrect'}
              handleClick={() => setAccurate('incorrect')}
              label="hazard_accurate_incorrect"
            />
            Incorrect
          </div>
          <div className="accuracy_selection">
            <Checkbox
              selected={accurate == 'manually_corrected'}
              handleClick={() => setAccurate('manually_corrected')}
              label="hazard_accurate_manually_corrected"
            />
            Manually Corrected
          </div>
        </div>
      </div>
      <div className="label_visibility section">
        Is the package labelling visible and not obscured by the packaging?
        <div className="label_visibility_checkboxes">
          <div className="visibility_selection">
            <Checkbox
              selected={visible == 'visible'}
              handleClick={() => setVisible('visible')}
              label="hazard_visible"
            />
            Visible
          </div>
          <div className="visibility_selection">
            <Checkbox
              selected={visible == 'not_visible'}
              handleClick={() => setVisible('not_visible')}
              label="hazard_not_visible"
            />
            Not Visible
          </div>
        </div>
      </div>
      <div className="update_button" onClick={() => updatePackageHazards()}>
        Update Hazardous Goods
      </div>
    </div>
  );
};

EditPackageHazards.propTypes = {
  packages: PropTypes.array,
  setModalOpen: PropTypes.func,
  refetchPackages: PropTypes.func,
};

export default EditPackageHazards;
